import api from "./client";

// Agent conversation surface (agent_actions lane, CRM api under /api/agent/).
// The assistant proposes actions; the CRM decides whether to execute. On a
// tenant in SHADOW mode the backend returns shadow:true and does NOT execute —
// proposals render as "would do" cards.
//
//   POST /agent/converse/  { message, conversation_id? }
//     -> { conversation_id, reply, proposals: [...], shadow: bool }
//
//   POST /agent/confirm/   { action_id, conversation_id? }
//   POST /agent/decline/   { action_id, conversation_id? }
//     -> execution result (or a shadow no-op marker on a shadow tenant)
//
// A proposals[] item carries an `action_id` (what confirm/decline reference).
// The card renders generically off the item's fields (summary/action_type/
// params) so it stays resilient to extra keys the contract may add.

// The default axios client times out at 20s (setupAxios defaults to 15s), but
// an agent turn is LLM-backed — a booking-intent converse does party
// resolution + availability lookup and routinely runs 20-60s. Without a longer
// per-request timeout the call aborts before a proposal is ever produced, which
// silently starves the shadow pilot (no proposal = nothing to grade). Give the
// agent calls their own generous timeout without loosening it app-wide.
const AGENT_TIMEOUT = 90000;

// mode: omit for OPERATOR (server resolves operator for authenticated staff);
// pass "customer" to DOWN-privilege (staff conversing as a customer — a test
// toggle). The server is authoritative and returns the resolved `mode`.
export const converse = (message, conversationId, mode) =>
  api.post("/agent/converse/", {
    message,
    ...(conversationId ? { conversation_id: conversationId } : {}),
    ...(mode ? { mode } : {}),
  }, { timeout: AGENT_TIMEOUT });

export const confirmAction = (actionId, conversationId) =>
  api.post("/agent/confirm/", conversationId
    ? { action_id: actionId, conversation_id: conversationId }
    : { action_id: actionId }, { timeout: AGENT_TIMEOUT });

export const declineAction = (actionId, conversationId) =>
  api.post("/agent/decline/", conversationId
    ? { action_id: actionId, conversation_id: conversationId }
    : { action_id: actionId }, { timeout: AGENT_TIMEOUT });
